const Unauthorized = () => {

    let today: Date = new Date();

    return (
        <div>
            <div id="main-nav">
                <div>
                    <div className="row align-items-center" style={{ margin: 0 }}>
                        <div className="navbar-logo">
                            <div id="essentials-logo"></div>
                        </div>
                        <div className="col navbar-env text-center fs-6">                            
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div className="p-4">
                    <div className="container">
                        <div className="row">
                            <div style={{ textAlign: 'center' }}>
                                <h2>Unauthorized</h2>                                
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6 mx-auto">
                                <div className="alert alert-info" role="alert">
                                    You do not have an active Essentials account. If you have not accessed Essentials
                                    in the past 90 days, your account may have been deactivated. Please contact the Help Desk
                                    to request access or to have your account reactivated.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{textAlign: 'center'} }>
                <div>
                    &copy;{today.getFullYear()} Surgery Partners
                </div>
            </div>
        </div>
    );
}

export default Unauthorized;